// extracted by mini-css-extract-plugin
export default {"myForm":"MyForm_myForm__32JfJ","myInput":"MyForm_myInput__pnI-O","myButton":"MyForm_myButton__N3XcR"};